import { BrowserRouter } from 'react-router-dom'
import '../assets/styles'
import { Router } from './Router'
import React, { useEffect, useState } from 'react'
import { CookiesProvider } from 'react-cookie'

import { api } from './configs'
import { Spinner } from './common'

const App = () => {
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    api.interceptors.request.use(config => {
      setLoading(true)
      return config
    })
    api.interceptors.response.use(
      response => {
        setLoading(false)
        return response
      },
      error => {
        setLoading(false)
        return error
      }
    )
  }, [])

  return (
    <CookiesProvider>
      <BrowserRouter>
        <Router />
        <Spinner loading={loading} />
      </BrowserRouter>
    </CookiesProvider>
  )
}

export { App }
